<template>
  <section class="section">
    <div class="columns is-centered">
      <div class="column is-two-thirds">
        <InfoBox
          v-if="buildMyCatalogue === null && hasProducts === false"
          :title="$t('dashboard.buildMyCatalogue.title')"
          :description="$t('dashboard.buildMyCatalogue.description')"
          :acceptLabel="$t('dashboard.buildMyCatalogue.yesButton')"
          :declineLabel="$t('dashboard.buildMyCatalogue.noButton')"
          :showInput="true"
          :inputLabel="$t('dashboard.buildMyCatalogue.urlLabel')"
          :inputPlaceholder="$t('dashboard.buildMyCatalogue.urlPlaceholder')"
          inputType="url"
          @accept="handleBuildCatalogue(true, $event)"
          @decline="handleBuildCatalogue(false)"
        />
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="box">
          <p>
            <strong v-if="status === 'onboarding'">{{ $t('dashboard.account.status.title') }}: {{ $t('dashboard.account.status.onboarding') }}</strong>
            <strong v-else-if="status ==='pending'">{{ $t('dashboard.account.status.title') }}: {{ $t('dashboard.account.status.pending') }}</strong>
            <strong v-if="status === 'active'">{{ $t('dashboard.account.status.title') }}: {{ $t('dashboard.account.status.active') }}</strong>
          </p>
          <p v-if="status === 'onboarding'">{{ $t('dashboard.account.status.onboardingMessage') }}</p>
          <p v-else-if="status === 'pending'">{{ $t('dashboard.account.status.pendingMessage') }}</p>
          <p v-else-if="status === 'active'">{{ $t('dashboard.account.status.activeMessage') }}</p>
        </div>

        <div class="box">
          <p>
            <span class="icon-text">
              <span class="icon"><i class="fa fa-check has-text-success"></i></span>
              <span><strong>{{ $t('dashboard.account.details.title') }}</strong></span>
            </span>
            <br />
            {{ $t('dashboard.account.details.detailsMessage') }}
          </p>
          <br/>
          <div class="field">
            <p class="control">
              <router-link to="/settings">
                <button class="button is-success is-fullwidth">{{ $t('app.buttons.edit') }}</button>
              </router-link>
            </p>
          </div>
        </div>

        <div class="box" v-if="hasShipping !== null">
          <p v-if="hasShipping === true">
            <span class="icon-text">
              <span class="icon"><i class="fa fa-check has-text-success"></i></span>
              <span><strong>{{ $t('dashboard.shipping.hasShippingTitle') }}</strong></span>
            </span>
          </p>
          <p v-else-if="hasShipping === false">
            <strong>{{ $t('dashboard.shipping.noShippingTitle') }}</strong>
          </p>
          <p v-if="hasShipping === true">
            {{ $t('dashboard.shipping.hasShippingtext') }}
          </p>
          <p v-else-if="hasShipping === false">
            {{ $t('dashboard.shipping.noShippingtext') }}
          </p>
          <br/>
          <div class="field">
            <p class="control">
              <router-link to="/shipping-methods">
                <button v-if="hasShipping === true" class="button is-success is-fullwidth">{{ $t('app.buttons.edit') }}</button>
                <button v-else-if="hasShipping === false" class="button is-success is-fullwidth">{{ $t('app.buttons.start') }}</button>
              </router-link>
            </p>
          </div>
        </div>
        <!-- <div class="box">
          <p>
            <strong>{{ $t('dashboard.shop.title') }}</strong>
          </p>
          <p>
            {{ $t('dashboard.shop.text') }}
          </p>
          <br/>
          <div class="field">
            <p class="control">
              <button class="button is-success is-fullwidth">{{ $t('app.buttons.continue') }}</button>
            </p>
          </div>
        </div> -->
      </div>
      <div class="column is-one-third">
        <div class="box">
          <p>
            <strong>{{ $t('dashboard.summary.accountInfo') }}</strong>
          </p>
          <p>{{ $t('dashboard.summary.newOrders') }}: {{ pendingOrdersCount }}</p>
          <p>{{ $t('dashboard.summary.commission') }}: {{ commission }} %</p>
        </div>
        <div class="box" v-if="hasPaymentAccount !== null">
          <p v-if="hasPaymentAccount === false">
            <strong>{{ $t('dashboard.payment.titles.noAccount') }}</strong>
          </p>
          <p v-else-if="hasPaymentAccount === true && isPaymentOnboardingCompleted === false">
            <strong>{{ $t('dashboard.payment.titles.noAccount') }}</strong>
          </p>
          <p v-else-if="hasPaymentAccount === true && isPaymentOnboardingCompleted === true">
            <span class="icon-text">
              <span class="icon"><i class="fa fa-check has-text-success"></i></span>
              <span><strong>{{ $t('dashboard.payment.titles.onboardingComplete') }}</strong></span>
            </span>
          </p>
          <p v-if="hasPaymentAccount === false">
            {{ $t('dashboard.payment.texts.noAccount') }}
          </p>
          <p v-else-if="hasPaymentAccount === true && isPaymentOnboardingCompleted === false">
            {{ $t('dashboard.payment.texts.onboardingUncomplete') }}
          </p>
          <p v-else-if="hasPaymentAccount === true && isPaymentOnboardingCompleted === true">
            {{ $t('dashboard.payment.texts.onboardingComplete') }}
          </p>
          <br/>
          <div v-if="hasPaymentAccount === false || isPaymentOnboardingCompleted === false" class="field">
            <p class="control">
              <router-link to="/payments">
                <button class="button is-success is-fullwidth">{{ $t('app.buttons.start') }}</button>
              </router-link>
            </p>
          </div>
        </div>
        <div class="box" v-if="hasProducts !== null">
          <p v-if="hasProducts === true">
            <span class="icon-text">
              <span class="icon"><i class="fa fa-check has-text-success"></i></span>
              <span><strong>{{ $t('dashboard.product.hasProductTitle') }}</strong></span>
            </span>
          </p>
          <p v-else-if="hasProducts === false">
            <strong>{{ $t('dashboard.product.noProductTitle') }}</strong>
          </p>
          <p v-if="hasProducts === true">{{ $t('dashboard.product.hasProductText') }}</p>
          <p v-else-if="hasProducts === false">{{ $t('dashboard.product.noProductText') }}</p>
          <br/>
          <div class="field">
            <p class="control">
              <router-link to="/add-product">
                <button v-if="hasProducts === true" class="button is-success is-fullwidth">{{ $t('app.buttons.add') }}</button>
                <button v-else-if="hasProducts === false" class="button is-success is-fullwidth">{{ $t('app.buttons.start') }}</button>
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import { FooshiApi } from '@/services/fooshiApi.service'
import InfoBox from '../components/InfoBox.vue'

export default {
  components: {
    InfoBox
  },
  methods: {
    initializeCrispChat () {
      window.$crisp = []
      window.CRISP_WEBSITE_ID = '362a0035-e7cf-47d8-80af-0459b7e74afd'
      const script = document.createElement('script')
      script.src = 'https://client.crisp.chat/l.js'
      script.async = true
      document.getElementsByTagName('head')[0].appendChild(script)
    },
    async getPaymentAccount () {
      var response = await FooshiApi.getPaymentAccount()
      if (response.success) {
        const data = response.data
        if (data.account == null) {
          this.hasPaymentAccount = false
        } else {
          if (data.account.accountId && data.stripe.charges_enabled === false) {
            this.hasPaymentAccount = true
            this.isPaymentOnboardingCompleted = false
          }
          if (data.account.accountId && data.stripe.charges_enabled === true) {
            this.hasPaymentAccount = true
            this.isPaymentOnboardingCompleted = true
          }
        }
      }
    },
    async createAccount () {
      await FooshiApi.createPaymentAccount()
      window.location.reload()
    },
    async getOnboardingStatus () {
      var response = await FooshiApi.getOnboardingStatus()
      if (response.success) {
        const data = response.data
        this.onboardingId = data.id
        this.step = data.step
        this.status = data.status
        this.hasShipping = data.hasShipping
        this.hasProducts = data.hasProducts
        this.buildMyCatalogue = data.buildMyCatalogue
      }
    },
    async getPendingOrdersCount () {
      var response = await FooshiApi.getOrderCountByStatus()
      if (response.success) {
        const data = response.data
        this.pendingOrdersCount = data.pending
      }
    },
    async getVendor () {
      var response = await FooshiApi.getVendor()
      if (response.success) {
        const data = response.data
        this.commission = data.commission * 100
      }
    },
    async handleBuildCatalogue (accepted, payload) {
      await FooshiApi.buildCatalogue({
        buildMyCatalogue: accepted,
        catalogueUrl: accepted && payload ? payload.inputValue : null
      })
      this.buildMyCatalogue = accepted
    }
  },
  async mounted () {
    await this.getOnboardingStatus()
    await this.getPaymentAccount()
    await this.getPendingOrdersCount()
    await this.getVendor()
    this.initializeCrispChat()
  },
  data () {
    return {
      hasPaymentAccount: null,
      isPaymentOnboardingCompleted: null,
      onboardingId: '',
      step: '',
      status: '',
      hasShipping: null,
      hasProducts: null,
      commission: null,
      pendingOrdersCount: null,
      buildMyCatalogue: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue